import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'action'
})
export class ActionPipe implements PipeTransform {

  transform(value: string): any {
    switch (value) {
      case 'add':
        return 'Alta';
      case 'update_rfs':
      case 'substitute_cfs':
      case 'modify':
        return 'Modificación';
      case 'delete':
        return 'Baja';
      case 'reprovision':
        return 'Reprovisión';
    }
  }

}
